import {registerAPIService} from './APIServicesRegistry';
import APIServiceBase from './APIServiceBase';

export default class ProjectConfigurationsApiService extends APIServiceBase {
    constructor() {
        super('ProjectConfigurations')
    }

    setProductSerialNumber(data) {
        return this.post('SetProductSerialNumber', data)
    }

    copyAndSave(projectId, configurationId) {
        return this.post('CopyAndSave', {projectId, configurationId})
    }

    verifyProductSerialNumberUniquess(productSerialNumber) {
        return this.get(`VerifyProductSerialNumberUniquess?productSerialNumber=${productSerialNumber}`)
    }
}

registerAPIService(ProjectConfigurationsApiService)